// import 'https://unpkg.com/lit-html@1.0.0-rc.2/lit-html.js?module';
import {GalleryElement, GalleryNavElement} from '../../components/zv/gallery/component';
import '../../components/zv/ymaps/component';
import {DialogElement} from '../../components/zv/dialog/component';
import '../../components/zv/gallery/component';
import {Web, Element, ZvEvent} from '../../libs/zv';

type ShopPicture = {
    '1X': { src: string };
    '2X': { src: string };
}
type ShopJson = {
    status: string;
    data: {
        pictures: ShopPicture[];
        objects: ShopObject[];
    };
}
type ShopObject = {
    id: string;
    name: string;
    sectionName: string;
    picture: ShopPicture;
    address: string;
    square: string;
    products: string[];
}
type ShopObjectPicturesJson = {
    status: string;
    data: {
        pictures: ShopPicture[];
    }
}
const templates = {
    objects(items: ShopObject[], options: {ajax: string}):DocumentFragment{
        let html = `
${items.reduce((acc, object, i) => acc + `<div class="shop-object" data-pictures-ajax="${options.ajax.replace('#code#', object.id)}">
    <div class="shop-object__picture">${object.picture?`
        <a href="#shop-object-${object.id}"><img src="${object.picture['1X'].src}"${object.picture['2X'] ?`srcset="${object.picture['2X'].src} 2x"`:''} alt="" itemprop="image"/></a>
    `:''}</div>
    <div class="shop-object__info">
        <div class="shop-object__name">
            <a href="#shop-object-${object.id}">${object.name}</a>
        </div>
        <address class="shop-object__address">${object.address}</address>
        <p class="shop-object__square margin-vertical--.75">Количество кв. метров: ${object.square}</p>
    ${object.products&&object.products.length?`
        <div class="shop-object__products">${object.products.join('<br />')}</div>
    `:''}
        <ul class="margin-vertical--.75">
            <li class="shop-object__type">${object.sectionName}</li>
        </ul>
    </div>
</div>`, '')}`;
        return document.createRange().createContextualFragment(html);
    },
    objectDialogGallery(pictures: ShopPicture[]):DocumentFragment{
        let html = `${pictures.length>0?`
<zv-dialog id="shop-photos">
    <zv-dialog-close class="dialog__close">&times;</zv-dialog-close>
    <zv-dialog-content class="width--100%">
        <zv-gallery class="gallery header__gallery" data-swipe="x" id="shop-gallery">
        ${pictures.length > 1 ?`
            <zv-gallery-nav class="gallery__nav gallery__nav--prev" data-direction="prev">◀</zv-gallery-nav>
            <zv-gallery-nav class="gallery__nav gallery__nav--next" data-direction="next">▶</zv-gallery-nav>
        `:''}
            <zv-gallery-stage class="gallery__stage">
            <zv-gallery-slides class="gallery__slides">
            ${pictures.reduce((acc, picture, i) => acc + `
                <zv-gallery-slide class="gallery__slide">
                    <img src="${picture['1X'].src}"${picture['2X'] ?`srcset="${picture['2X'].src} 2x"`:''} />
        </zv-gallery-slide>
            `, '')}
                </zv-gallery-slides>
            </zv-gallery-stage>
        </zv-gallery>
    </zv-dialog-content>
</zv-dialog>
`:''}`;
        return document.createRange().createContextualFragment(html);
    },
    gallery(pictures: ShopPicture[]):DocumentFragment{
        let html = `
${pictures.slice(0, 1).reduce((acc, picture, i) => acc + `
<zv-gallery-nav
        data-gallery="shop-gallery"
        data-slide="${i}"
        data-passive="1"
        class="detail-pictures__picture detail-pictures__picture--main height--12 height--sm-min-18">
        <a href="#shop-photos">
            <picture>
                <img src="${picture['1X'].src}"${picture['2X'] ?`srcset="${picture['2X'].src} 2x"`:''} alt="" />
            </picture>
        </a>
</zv-gallery-nav>
`, '')}
${pictures.slice(0, 4).reduce((acc, picture, i) => acc + `
<zv-gallery-nav
        data-gallery="shop-gallery"
        data-slide="${i}"
        data-passive="1"
        class="detail-pictures__picture height--4">
        <a href="#shop-photos">
            <picture>
                <img src="${picture['1X'].src}"${picture['2X'] ?`srcset="${picture['2X'].src} 2x"`:''} alt="" />
            </picture>
        </a>
</zv-gallery-nav>
`, '')}
${pictures.length>4?`
<zv-gallery-nav
        data-gallery="shop-gallery" 
        data-slide="4" 
        data-passive="1"
        class="detail-pictures__pictures-more">
        <a href="#shop-photos">+ ${pictures.length - 4} фото</a>
</zv-gallery-nav>`:''}
${pictures.length>0?`
<zv-dialog id="shop-photos">
    <zv-dialog-close class="dialog__close">&times;</zv-dialog-close>
    <zv-dialog-content class="width--100%">
        <zv-gallery class="gallery header__gallery" data-swipe="x" id="shop-gallery">
        ${pictures.length > 1 ?`
            <zv-gallery-nav class="gallery__nav gallery__nav--prev" data-direction="prev">◀</zv-gallery-nav>
            <zv-gallery-nav class="gallery__nav gallery__nav--next" data-direction="next">▶</zv-gallery-nav>
        `:''}
            <zv-gallery-stage class="gallery__stage">
                <zv-gallery-slides class="gallery__slides">
                ${pictures.reduce((acc, picture, i) => acc + `
                    <zv-gallery-slide class="gallery__slide">
                        <img src="${picture['1X'].src}"${picture['2X'] ?`srcset="${picture['2X'].src} 2x"`:''} />
                    </zv-gallery-slide>
                `, '')}
                </zv-gallery-slides>
            </zv-gallery-stage>
        </zv-gallery>
    </zv-dialog-content>
</zv-dialog>
`:''}
`;
        return document.createRange().createContextualFragment(html);
    }
};
export class ShopDetailElement extends HTMLElement {
    responseJson?: ShopJson;
    gallery?: GalleryElement;
    galleryCntr: HTMLElement | null = this.querySelector('[data-shop-detail-gallery]');
    objectsCntr: HTMLElement | null = this.querySelector('[data-shop-detail-objects]');
    constructor(){
        super();
    }
    async connectedCallback(){
        // this.initElements();
        await this.connected()
    }
    async connected(){
        try {
            const shopResponse = await this.fetchShop();
            this.responseJson = <ShopJson>await shopResponse.json();
            this.buildPictures();
            this.buildObjects();
        }catch (e) {

        }
    }
    async fetchShop(){
        return Web.ajax(this.dataset.ajax!, {method: 'POST'});
    }
    async fetchObjectPictures(url: string){
        return Web.ajax(url, {method: 'POST'});
    }
    buildPictures(){
        if(
            !this.galleryCntr ||
            !this.responseJson ||
            !this.responseJson.data.pictures ||
            !this.responseJson.data.pictures.length){
            return
        }
        const gallery = templates.gallery(this.responseJson.data.pictures);
        this.galleryCntr.appendChild(gallery);
        return;
    }
    buildObjects(){
        if(!this.objectsCntr ||
            !this.responseJson ||
            !this.responseJson.data.objects ||
            !this.responseJson.data.objects.length){
            return
        }
        const objects = templates.objects(this.responseJson.data.objects, {
            ajax: this.objectsCntr.dataset.shopDetailObjectsAjaxTemplate!
        });
        this.objectsCntr.appendChild(objects);
        if(this.objectsCntr.dataset.shopDetailObjectsAjaxTemplate){
            this.objectsCntr
                .querySelectorAll('a')
                .forEach((item)=>item.addEventListener('click', this.objectGalleryCallback.bind(this)));
            // this.objectsCntr.addEventListener('click', Element.delegate('.shop-object__name a', this.objectGalleryCallback.bind(this)));
        }
        return;
    }
    async objectGalleryCallback(e:Event){
        const delegateTarget = <HTMLAnchorElement>e.target;
        const $shopObject = <HTMLElement>(delegateTarget).closest('.shop-object');
        if($shopObject.querySelector('zv-dialog')){
            return true;
        }
        e.preventDefault();
        const shopObjectPicturesResponse = await this.fetchObjectPictures($shopObject.dataset.picturesAjax!);
        const shopObjectPicturesJson = <ShopObjectPicturesJson>await shopObjectPicturesResponse.json();
        const gallery = templates.objectDialogGallery(shopObjectPicturesJson.data.pictures);
        const galleryDialog = <DialogElement>gallery.querySelector('zv-dialog');
        galleryDialog.id = delegateTarget.href.split('#')[1];
        $shopObject.appendChild(gallery);
        (<DialogElement>$shopObject.querySelector('zv-dialog')).active = true;
        return false;
    }
}
customElements.define('zv-shop-detail', ShopDetailElement);
// export class ShopObjectElement extends HTMLElement {
//     bar = 101;
//     constructor(){
//         super();
//     }
//     async fetchObjects(){
//         if(!this.dataset.ajax){
//             return;
//         }
//         try {
//             let objectResponse = await Web.ajax(this.dataset.ajax!);
//             let objects = objectResponse.json();
//         }catch (e) {
//             console.trace(e);
//         }
//     }
// }
// customElements.define('zv-shop-object', ShopObjectElement);